export default "__VITE_ASSET__C6kP0eaC__"